<script>
    /** @type {string} */
    export let customCss = '';
    /** @type {string} */
    export let text = '';
    /** @type {string} */
    export let icon = '';
    /** @type {string} */
    export let block = '';

    if (icon && block) {
        console.error(`Both "icon" and "block" can not be used at the same time.`);
    }
</script>

<td class="prom-table-cell">
    <div class="prom-table-cell__data {customCss}">
        {#if icon}
            <img class="prom-table-cell__icon" src={icon} alt="" />
        {:else if block}
            <span class={`prom-table-cell__block ${block}`}></span>
        {/if}
    
        {#if text}
            <span class="prom-table-cell__text">{text}</span>
        {:else}
            <slot></slot>
        {/if}
    </div>
</td>
